<template>
  <el-container class="index-con">
    <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
      <navcon></navcon>
    </div>
    <div class="index-page"></div>
    <!-- banner -->
    <div class="banner">
      <el-carousel trigger="click" :height="height + 'px'">
        <el-carousel-item v-for="item,index in banner" :key="index">
          <img class="banner" ref="height1" @load="imgLoad" :src="item.bannerImg" @click="onTransParam(item.transParam)">
        </el-carousel-item>
      </el-carousel>
    </div>
    

    <div style="padding-top: 40px;">
      <div class="main-con">
        <div class="navs-search">
          <div style="width: 300px;">
            <el-input placeholder="请输入搜索内容" v-model="searchContent" class="input-with-select" @change="getSelect">
              <el-button slot="append" type="warning" icon="el-icon-search" circle @click="getSelect"></el-button>
            </el-input>
          </div>
        </div>

        <!-- 分类 -->
        <div class="category">
          <div class="category-item">
            <p class="category-name">类别：</p>
            <ul>
              <li v-for="item,index in categoryList" :key="index" :class="index==categoryCur?'cur':''" @click="onCategory(index,item.id)">{{ item.levelName }}</li>
            </ul>
          </div>
          <div class="category-item">
            <p class="category-name">状态：</p>
            <ul>
              <li v-for="item,index in stateList" :key="index" :class="index==stateCur?'cur':''" @click="onState(index)">{{ item }}</li>
            </ul>
          </div>
          <div class="category-item">
            <p class="category-name">形式：</p>
            <ul>
              <li v-for="item,index in shapeList" :key="index" :class="index==shapeCur?'cur':''" @click="onShape(index)">{{ item }}</li>
            </ul>
          </div>
        </div>

        <!-- 考试列表 -->
        <div class="authentication">
          <div class="grades">
            <ul>
              <li v-for="item,index in examItem" :key="index"  @click="onExamDetails(item.id)">
                <p class="grades-type grades-type-cur1" v-if="item.signStatus==1">未开始</p>
                <p class="grades-type grades-type-cur2" v-else-if="item.signStatus==2">报名中</p>
                <p class="grades-type grades-type-cur3" v-else>已结束</p>
                <img :src="item.examImg" alt="">
                <div class="grades-content">
                  <p class="title">{{item.examName}}</p>
                  <div class="on-line">
                    <i class="el-icon-suitcase-1" style="font-size: 14px;color: #c4c3c6;"></i>
                    <p class="time">报名:{{item.signStartTime.split(' ')[0]}}-{{item.signEndTime.split(' ')[0]}}</p>
                  </div>
                  <div class="on-line">
                    <i class="el-icon-suitcase-1" style="font-size: 14px;color: #c4c3c6;"></i>
                    <p class="time">考试:{{item.examStartTime.split(' ')[0]}}-{{ item.examEndTime.split(' ')[0] }}</p>
                  </div>
                </div>
                <div class="grades-bottom">
                  <div style="display: flex;align-items: center;">
                    <span class="moeny" v-if="item.ifFree==0">￥{{ item.salePrice }}</span>
                    <span class="ticket" v-if="item.ifFree==0">券</span>
                    <span class="moeny" v-else style="font-size: 12px;line-height: 12px;">免费</span>
                    <span class="offline">{{ item.examForm==0?'线下':'线上' }}</span>
                  </div>
                  <p class="know">了解详情 ></p>
                </div>
              </li>
            </ul>
          </div>
          <div class="pagination">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :current-page="page"
              :page-size="rows"
              @current-change="currentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
      <footers></footers>
    </el-footer>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../../components/navcon.vue'
import footers from '../../components/footers.vue'
import { bannerList, subjectList, examList } from '../../api/userMG'
export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      categoryList:[
        {
          id:'',
          levelName:'全部'
        }
      ],
      categoryCur:0,

      stateList:['全部','未开始','报名中','已结束'],
      stateCur:0,

      shapeList:['全部','线下','线上'],
      shapeCur:0,
      
      examItem:[],
      examType:'',
      examStatus:'',
      examForm:'',

      page:1,
      rows:16,
      total:0,
      
      banner:[],
      height:'',
      searchContent:''
    }
  },
  watch: {
    '$route'(to, from) {
      // 更新搜索内容
      this.searchContent = to.query.keyWord;
      // 重新获取课程列表
      this.getExamList();
    }
  },
  // 注册组件
  components: {
    navcon,
    footers,
  },
  computed: {
    url() {
      return this.$store.getters.url;
    }
  },
  created() {
    this.searchContent = this.$route.query.keyWord;
    this.getSubjectList();
    this.getExamList();
    this.getBannerList();
  },
  mmounted() {
    this.imgLoad()
    window.addEventListener('resize',()=>{
      this.height =  this.$refs.height1[0].height
      this.imgLoad()
    })
  },
  methods:{
    imgLoad(){
      var _that = this
      this.$nextTick(()=>{
        _that.height = _that.$refs.height1[0].height
        _that.$emit('style1',_that.height)//如果是子组件，就给父组件传递高度，设定父组件的高度
      })
    },
    // 获取banner
    getBannerList(){
      bannerList({location:2}).then(res => {
        console.log('banner',res.data);
        this.banner = res.data
      })
      .catch(err => {})
    },
    onTransParam(url){
      if(url){
        window.open(url)
      }
    },
    // 获取科目列表
    getSubjectList(){
      subjectList({type:1}).then(res => {
        let categoryList = res.data;
        categoryList.forEach((item,i) => {
          this.categoryList.push({
            id:item.id,
            levelName:item.levelName
          });
        })
        
        console.log('科目列表',this.categoryList);
      })
    },
    getSelect(){
      this.page = 1;
      this.getExamList();
    },
    // 获取考试报名列表
    getExamList(){
      let params = {
        page:this.page,
        rows:this.rows,
        examSubject:this.examType,
        signStatus:this.examStatus==0?'':this.examStatus,
        examForm:this.examForm==-1?'':this.examForm,
        searchContent:this.searchContent
      }
      // const loading = this.$loading({
      //   lock: true,
      //   text: '加载中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0)'
      // });
      examList(params).then(res => {
        console.log('考试数据',res);
        this.total = res.data.total;
        this.examItem = res.data.content;
        // loading.close();
      })
      // .catch(err => {
      //   loading.close();
      // })
    },
    currentChange(e){
      console.log("分页变化",e)
      this.page = e;
      this.getExamList();
    },
    onCategory(e,id){
      this.categoryCur = e;
      this.examType = id;
      this.getExamList();
    },
    onState(e){
      this.stateCur = e;
      this.examStatus = e;
      this.getExamList();
    },
    onShape(e){
      this.shapeCur = e;
      this.examForm = e-1;
      this.getExamList();
    },
    onExamDetails(id){
      this.$router.push({path:'/index/examDetails', query: { id: id, type:1 }})
    }
  }
}
</script>
<style scoped>
  .banner{
    width: 100%;
    cursor: pointer;
  }
  @media (min-width: 1366px) {
    .main-con { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .main-con {
      width: 1300px;
    }
  }

  .main-con {
    margin: auto;
    padding-bottom: 40px;
  }
  .index-con {
    height: 100%;
    box-sizing: border-box;
    margin: auto;
  }
  .category{
    padding: 16px 20px;
    border-radius: 8px;
    margin-bottom: 40px;
    background: #fafafa;

  }
  .category-item{
    display: flex;
    align-items: center;
    padding: 10px 0;
  }
  .category-name{
    border-left: 3px solid #ff821c;
    padding-left: 6px;
    font-size: 13px;
    line-height: 14px;
    font-weight: 600;
  }
  .category ul{
    display: flex;
    align-items: center;
  }
  .category ul li{
    font-size: 13px;
    /* font-weight: 600; */
    color: #5c5c5c;
    margin: 0 17px;
    padding: 2px 16px;
    cursor: pointer;
  }
  .category ul li:hover{
    color: #ff821c;
  }
  .category ul .cur{
    background: #faede5;
    color: #ff821c;
    border: none !important;
    border-radius: 20px;
  }
  .aside {
    width: 64px !important;
    height: 100%;
    background-color: #334157;
    margin: 0px;
  }
  .asideshow {
    width: 240px !important;
    height: 100%;
    margin: 0px;
  }
  .index-main{
    margin-left: 20px !important;
  }
  .index-header,
  .index-main,
  .index-footer {
    padding: 0px;
    height: auto;
    margin: 0; 
  }

  .cur{
    color: #e76742 !important;
    border-bottom: 2px solid #f7ece6 !important;
  }
  .grades ul{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .grades ul li{
    background-color: #fafafa;
    width: 23.5%;
    box-shadow: 0 0 20px rgba(222, 207, 207, 0.8);
    border: 1px solid #e8e9ed;
    border-top: none;
    border-radius: 10px;
    margin-right: 17px;
    margin-bottom: 17px;
    transition: transform 0.3s ease-in-out; /* 动画持续时间和动画类型 */
    transform: translateY(0); /* 初始状态，不移动 */
    position: relative;
  }
  .grades ul li:nth-child(4){
    margin-right: 0;
  }
  .grades ul li:nth-child(8){
    margin-right: 0;
  }
  .grades ul li:nth-child(12){
    margin-right: 0;
  }
  .grades ul li:nth-child(16){
    margin-right: 0;
  }
  .grades ul li:hover{
    /* background-image: linear-gradient(bottom,#f9efe3 , #fff); */
    background: #fff;
    transform: translateY(-10px);
    box-shadow: 0 0 20px rgba(190, 173, 173, 0.8);
  }
  .grades-type{
    position: absolute;
    top: 0;
    left: 0;
    padding: 2px 8px;
    font-size: 11px;
    border-top-left-radius: 6px;
    border-bottom-right-radius: 8px;
    color: #fff;
  }
  .grades-type-cur1{
    background: linear-gradient(-28deg, #2970DA, #74AAFA);
  }
  .grades-type-cur2{
    background: linear-gradient(-28deg, #FF5500, #FF9C00);
  }
  .grades-type-cur3{
    background: linear-gradient(-28deg, #EC192A, #FF7D66);
  }
  .grades ul li{
    cursor: pointer;
  }
  .grades ul li img{
    width: 100%;
    /* height: 133px; */
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  }
  .grades-content{
    margin:0 16px;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
  }
  .grades ul li .title{
    font-size: 15px;
    font-weight: 500;
    color: black;
    margin-bottom: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .on-line{
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }
  .on-line .type{
    font-size: 10px;
    color: black;
    width: 54px;
    height: 20px;
    border-radius: 4px;
    background: #fff2e9;
    color: #f15903;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px;
  }
  .on-line .time{
    font-size: 11px;
    line-height: 12px;
    color: #9b9b9b;
    margin-left: 12px;
    margin-left: 4px;
  }
  .grades ul li .text{
    font-size: 12px;
    color: #686868;
    margin-bottom: 28px;
  }
  .grades .button{
    width: 100%;
    height: auto;
  }
  .grades-bottom{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
  }
  .grades-bottom .moeny{
    font-size: 18px;
    line-height: 18px;
    color: #f45904;
    margin-right: 5px;
  }
  .grades-bottom .ticket{
    font-size: 11px;
    line-height: 11px;
    padding: 4px 5px ;
    background-color: #ff811e;
    color: #fff;
    border-radius: 2px;
    margin: 0 6px 0 0;
  }
  .grades-bottom .offline{
    font-size: 11px;
    padding: 2px 8px;
    background-color: #f7ede4;
    color: #f15e09;
    border-radius: 2px;
  }
  .grades-bottom .know{
    font-size: 13px;
    color: #f15903;
  }
  .el-pagination{
    text-align: center;
    margin-top: 25px;
  }
  .pagination /deep/ .active{
    background: #ff821c !important;
  }
  /* .pagination /deep/ .number:hover{
    color: #ff821c !important;
  } */
  .navs-search{
    border-bottom: 1px solid #e5e5e5;
    padding: 0 0 16px;
    margin-bottom: 32px;
    display: flex;
    align-content: center;
    justify-content: flex-end;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/exam.vue